import { useCallback, useEffect, useState } from "react";
import axios, { API, KGF_API } from "../lib/api";

export default function useLive(intervalMs = 10000) {
  const [data, setData] = useState(null);
  const [plantStatus, setPlantStatus] = useState(null);
  const [plantStatusError, setPlantStatusError] = useState(false);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    const [liveResult, plantResult] = await Promise.allSettled([
      axios.get(`${API}/live`),
      axios.get(`${KGF_API}/plant-status`),
    ]);

    if (liveResult.status === "fulfilled") {
      setData(liveResult.value.data);
      setError(false);
    } else {
      setError(true);
    }

    if (
      plantResult.status === "fulfilled" &&
      plantResult.value.data?.ok &&
      plantResult.value.data?.plant
    ) {
      setPlantStatus(plantResult.value.data.plant);
      setPlantStatusError(false);
    } else {
      setPlantStatusError(true);
    }
  }, []);

  useEffect(() => {
    load();
    const timer = setInterval(load, intervalMs);
    return () => clearInterval(timer);
  }, [load, intervalMs]);

  return {
    plant: plantStatus ?? data?.plant ?? null,
    plantStatusError,
    products: Array.isArray(data?.products) ? data.products : [],
    history: Array.isArray(data?.history) ? data.history : [],
    rates: data?.rates ?? null,
    closures: Array.isArray(data?.closures) ? data.closures : [],
    error,
    reload: load,
  };
}
